// @flow
// $FlowFixMe
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './ContentfulImage.css';
import Qs from 'qs';

type OwnProps = {
  src: string,
  className?: string,
  srcSet?: string,
  options?: Object,
  alt: string,
};

const ContentfulImage = ({ src, className, options, alt, ...props }: OwnProps) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const imgRef = useRef(null);
  const imageUrl = options ? `${src}?${Qs.stringify(options)}` : src;

  const onLoad = () => {
    setLoaded(true);
  };

  const onError = () => {
    setError(true);
  };

  useEffect(() => {
    const imgElement = imgRef.current;

    if (imgElement && imgElement.complete) {
      if (imgElement.naturalWidth === 0) {
        onError();
      } else {
        onLoad();
      }
    }
  }, [src]);

  return (
    <img
      {...props}
      ref={imgRef}
      src={imageUrl}
      className={classNames(className, styles.image, {
        [styles.loaded]: loaded,
        [styles.error]: error,
      })}
      alt={alt}
      loading="lazy"
      decoding="async"
      draggable={false}
      onError={onError}
      onLoad={onLoad}
    />
  );
};

export default ContentfulImage;
